import React, {useState} from 'react';
import {Button, Card, Drawer, Input, PageHeader, Table} from 'antd';
import useCollectionWorkProject, {ICollectionWorkProject} from '../../hooks/apis/useCollectionWorkProject';
import Flex from '../Flex';
import {useBoolean} from 'react-hanger';
import CollectionWorkProjectEditForm from './EditForm';
import {CollectionWorkProjectType} from '../../hooks/apis/useCollectionWork';
import {CollectionWorkProjectStatusConfig} from '../../hooks/apis/useCollectionWorkProjectRecord';
import CommonApiErrorHandler from '../../utils/HttpInstance';

const CollectionWorkProjectList = (props: {collectionWorkId?: number; onFinish?: () => any}) => {
  const isAdd = useBoolean(false);
  const isEdit = useBoolean(false);
  const [selected, setSelected] = useState<ICollectionWorkProject>();
  const listHook = useCollectionWorkProject.list();

  function refresh() {
    listHook
      .request({
        collectionWorkId: props.collectionWorkId,
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  React.useEffect(() => {
    refresh();
  }, [props.collectionWorkId]);

  return (
    <div>
      <Card
        size={'small'}
        bodyStyle={{padding: 0}}
        title={
          <Flex justify={'flex-end'}>
            <Button type={'primary'} onClick={isAdd.setTrue}>
              新增征集项目
            </Button>
          </Flex>
        }>
        <Table<ICollectionWorkProject> dataSource={listHook.data} bordered>
          <Table.Column title="征集项目名称" dataIndex="name" />
          <Table.Column title="征集项目类型" dataIndex="type" render={_ => CollectionWorkProjectType[_]} />
          <Table.Column title="文件大小限制" dataIndex="fileSizeMb" render={_ => _ + ' Mb'} />
          <Table.Column title="备注" dataIndex="remark" />
          <Table.Column<ICollectionWorkProject>
            title="操作"
            render={(_, row) => (
              <Button
                type={'link'}
                onClick={() => {
                  setSelected(row);
                  isEdit.setTrue();
                }}>
                编辑
              </Button>
            )}
          />
        </Table>
      </Card>
      <Drawer visible={isAdd.value} onClose={isAdd.setFalse} destroyOnClose={true} title="新增征集项目" width={600}>
        <CollectionWorkProjectEditForm
          collectionWorkId={props.collectionWorkId}
          onFinish={() => {
            refresh();
            props.onFinish && props.onFinish();
            isAdd.setFalse();
          }}
        />
      </Drawer>
      <Drawer visible={isEdit.value} onClose={isEdit.setFalse} destroyOnClose={true} title="修改征集项目" width={600}>
        <CollectionWorkProjectEditForm
          collectionWorkId={props.collectionWorkId}
          collectionWorkProject={selected}
          onFinish={() => {
            refresh();
            props.onFinish && props.onFinish();
            isEdit.setFalse();
          }}
        />
      </Drawer>
    </div>
  );
};
export default CollectionWorkProjectList;
